import { useEffect, useState } from "react";
import { useDebouncedSearch } from "../../../../hooks/useDebouncedSearch";
import { useNavigate } from "react-router-dom";
import Grid, { GridColumn, GridHeader, GridRow } from "../../../../components/Grid/Grid";
import WebService, { BASE_URL } from "../../../../utility/WebService";
import WarningModal from "../../../../components/Warning/Warning";
import SucessModal from "../../../../components/SucessModal/Sucess";
import recoverIcon from '../../../../assets/images/icons8-reset-24.png';
import BackComponent from "../../../../components/BackArrow";
import HelperService from "../../../../utility/HelperService";
import { TbDownload } from "react-icons/tb";
import SpringMoneyPagination from "../../../../components/SpringMoney/Pagination/SpringMoneyPagination";
import { toast } from "../../../../components/AppModal/AppModal";
import "../../Masters/MasterList.css";
import { useMenuBack } from "../../../../hooks/useMenuBack";

/* ---- inline stroke icons (apv style, kept local to this screen) ---- */
const IconSearch = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" /></svg>
);
const IconDownload = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v12" /><path d="M7 10l5 5 5-5" /><path d="M5 21h14" /></svg>
);
const IconBack = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
);
const IconArrowRight = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 5l7 7-7 7" /></svg>
);
const IconStar = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 18.8 6.2 21.9l1.1-6.5L2.6 10.7l6.5-.9L12 3z" /></svg>
);

const ArchivedAgreement = () => {
  const goBack = useMenuBack();
    const [rows, setRows] = useState<GridRow[]>([]);
    const [list, setList] = useState<any[]>([]);
    const [ShowLoader, setShowLoader] = useState(false);
    const [totalCount, setTotalCount] = useState("");
    const [sucessMessage, setSucessMessage] = useState<any>()
    const [isShowSucessModal, setShowSucessModal] = useState(false);
    const [warningMessage, setWarningMessage] = useState<any>()
    const [isShowWarningModal, setShowWarningModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1)
    const [searchText, setSearchText] = useState("");
  const appliedSearch = useDebouncedSearch(searchText);
    const [TotalPages, setTotalPages] = useState<number>();
    const [goToPageNumber, setGoToPageNumber] = useState<string>("");
    const user_data = JSON.parse(localStorage.getItem("user_Detail") || "{}");
    let history = useNavigate();
    const pmUserDetail: any = (() => { try { return JSON.parse(localStorage.getItem("user_Detail") || "{}"); } catch (e) { return {}; } })();
    const pageSizeKey = "ml_pagesize_archived_agreement_page_size_" + (pmUserDetail?.user_id || "default");
    const PAGE_SIZES = [10, 25, 100, 250, 500];
    const readSavedPageSize = () => {
        const v = parseInt(localStorage.getItem(pageSizeKey) || "", 10);
        return PAGE_SIZES.indexOf(v) >= 0 ? v : 100;
    };
    const [itemsCountPerPage, setItemsCountPerPage] = useState<number>(() => readSavedPageSize());
    const [defaultPageSize, setDefaultPageSize] = useState<number>(() => readSavedPageSize());

    useEffect(() => {
        getList(1, "");
    }, []);

    // load the user's saved default page size from their account so it follows
    // them across devices (localStorage above is just an instant local cache)
    useEffect(() => {
        WebService.getAPI({ action: `/v2/UserSetting/Get?key=archived_agreement_page_size`, body: null })
            .then((res: any) => {
                const v = parseInt(res?.value, 10);
                if (PAGE_SIZES.indexOf(v) >= 0) {
                    setDefaultPageSize(v);
                    setItemsCountPerPage(v);
                    try { localStorage.setItem(pageSizeKey, String(v)); } catch (e) { }
                }
            })
            .catch(() => { });
    }, []);

    useEffect(() => {
        getList(currentPage, searchText);
    }, [appliedSearch, currentPage, itemsCountPerPage]);

    const download = (id: any) => {
        setShowLoader(true);
        window.open(`${BASE_URL}/v2/ClientAgreements/DownloadFinalDocument?id=${id}`)
        setShowLoader(false)
    }

    const getList = (page?: any, searchText?: string) => {
        setShowLoader(true);
        WebService.getAPI({
            action: `${user_data.is_person == 'Employee' ? `/v2/ClientAgreements/GetAgreementArchiveList` : `/v2/ClientAgreements/GetClientArchiveAgreementList`}?page=${page}&keyword=${encodeURIComponent(appliedSearch)}&status=COMPLETED&limit=${itemsCountPerPage}`,
        })
            .then((res: any) => {
                setTotalCount(res.total_count);
                setList(res.list || []);
                setShowLoader(false);
                let rows: GridRow[] = [];
                for (let i in res.list) {
                    let columns: GridColumn[] = [];
                    columns.push({ value: res.list[i].client_name ? res.list[i].client_name  : "-"});
                    columns.push({ value: res.list[i].agreement_type === 'AADHAR_E_SIGN' ? 'Aadhar E-Sign' :
                        res.list[i].agreement_type === 'E_SIGN' ? 'Wet Sign' :
                        res.list[i].agreement_type === 'SCANED_BY_BOTH' ? 'Physical' :
                        "-"});
                    columns.push({ value: res.list[i].ip_client ? res.list[i].ip_client : "-"});
                    columns.push({ value: res.list[i].client_signed_date ? HelperService.getFormatedDateAndTime(res.list[i].client_signed_date) : "-"});
                    columns.push({ value: res.list[i].advisor_signed_date ? HelperService.getFormatedDateAndTime(res.list[i].advisor_signed_date) : "-"});
                    columns.push({ value: res.list[i].start_date ? HelperService.getFormatedDateByDMY(res.list[i].start_date) : "-"});
                    columns.push({ value: res.list[i].end_date ? HelperService.getFormatedDateByDMY(res.list[i].end_date) : "-"});
                    // columns.push({ value: res.list[i].created_at ? HelperService.getFormatedDateByDMY(res.list[i].created_at) : "-"});
                    columns.push({
                        value: (
                            <a href="javascript:void(0)" className="action-btn" title="Download">
                                <TbDownload size={20} className="mr-3 text-brand" onClick={() => download(res.list[i].id)} />
                            </a>
                        )
                    });

                    rows.push({ data: columns });
                }
                setRows(rows);
            })
            .catch(() => {
                setShowLoader(false);
            });
    };

    const onSorting = (page: number, searchText: string) => {
        setCurrentPage(page)
        getList(page, searchText);
    };

    const handlePagination = (itemCount: number) => {
        setItemsCountPerPage(itemCount);
        setCurrentPage(1);
    };

    // remember the current page size for this user's next login (per-browser +
    // synced to the account so it follows the user across devices)
    const saveDefaultPageSize = () => {
        try {
            localStorage.setItem(pageSizeKey, String(itemsCountPerPage));
        } catch (e) { }
        setDefaultPageSize(itemsCountPerPage);
        WebService.postAPI({
            action: `/v2/UserSetting/Save`,
            body: { key: "archived_agreement_page_size", value: String(itemsCountPerPage) }
        }).catch(() => { });
        toast.success(`Showing ${itemsCountPerPage} per page by default from now on.`);
    };

    const handleGoToPageInput = (e: any) => {
        if (e.key === "Enter" && goToPageNumber !== "") {
            if (TotalPages && Number(goToPageNumber) > TotalPages) {
                setCurrentPage(TotalPages);
            } else {
                setCurrentPage(Number(goToPageNumber));
            }
        }
    };

    const sucessCloseModal = () => {
        setShowSucessModal(false)
        setShowLoader(false);
    }
    const warningCloseModal = () => {
        setShowWarningModal(false)
        setShowLoader(false);
    }

    const agreementTypeLabel = (t: any) =>
        t === 'AADHAR_E_SIGN' ? 'Aadhar E-Sign' :
        t === 'E_SIGN' ? 'Wet Sign' :
        t === 'SCANED_BY_BOTH' ? 'Physical' : "-";

    return (
        <>
            <WarningModal
                show={isShowWarningModal}
                isClose={warningCloseModal}
                message={warningMessage}
            />
            <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            />
            <div className="page-content-wraper ml-page">
                <div className="ml-head">
                    <div className="ml-head-l">
                        <button type="button" className="ml-back" title="Back" onClick={() => goBack()}>
                            <IconBack />
                        </button>
                        <div>
                            <h1 className="ml-title">Archived Agreement</h1>
                            <div className="ml-sub">MIS Report &middot; Completed / expired agreements</div>
                        </div>
                    </div>
                    <div className="ml-head-r">
                    </div>
                </div>

                <div className="ml-card">
                    <div className="ml-toolbar">
                        <div className="ml-sizes">
                            <span>Show:</span>
                            {PAGE_SIZES.map((size) => (
                                <button
                                    key={size}
                                    type="button"
                                    onClick={() => handlePagination(size)}
                                    className={`ml-size-btn ${itemsCountPerPage === size ? "active" : ""}`}
                                >
                                    {size}
                                </button>
                            ))}
                            <span className="ml-sizes-sep"></span>
                            <button
                                type="button"
                                className="ml-setdefault"
                                onClick={saveDefaultPageSize}
                                disabled={itemsCountPerPage === defaultPageSize}
                                title="Remember this page size for your next login"
                            >
                                <IconStar /> Set as default
                            </button>
                            <span className="ml-defnote">Default: {defaultPageSize}</span>
                        </div>
                        <div className="ml-tools">
                            <div className="ml-search">
                                <IconSearch />
                                <input
                                    onChange={(e) => { setSearchText(e.target.value); setCurrentPage(1); }}
                                    value={searchText}
                                    type="search"
                                    placeholder="Search agreements…"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="ml-tablewrap">
                        <table className="ml-table">
                            <thead>
                                <tr>
                                    <th>Client Name</th>
                                    <th>Agreement Type</th>
                                    <th>Client Ip</th>
                                    <th>Client Signed Date</th>
                                    <th>Advisor Signed Date</th>
                                    <th>Agreement Start Date</th>
                                    <th>Agreement End Date</th>
                                    <th className="text-center" style={{ width: "95px" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ShowLoader && Array.from({ length: 8 }).map((_, i) => (
                                    <tr key={'sk-' + i} className="ml-skrow">
                                        <td><span className="ml-sk" style={{ width: "60%" }}></span></td>
                                        <td><span className="ml-sk" style={{ width: "50%" }}></span></td>
                                        <td><span className="ml-sk" style={{ width: "50%" }}></span></td>
                                        <td><span className="ml-sk" style={{ width: "70%" }}></span></td>
                                        <td><span className="ml-sk" style={{ width: "70%" }}></span></td>
                                        <td><span className="ml-sk" style={{ width: "55%" }}></span></td>
                                        <td><span className="ml-sk" style={{ width: "55%" }}></span></td>
                                        <td className="text-center"><span className="ml-sk ml-sk-pill" style={{ width: "28px", margin: "0 auto" }}></span></td>
                                    </tr>
                                ))}
                                {!ShowLoader && list?.length > 0 && list.map((res: any, index: number) => {
                                    return (
                                        <tr key={index}>
                                            <td className="ml-name">{res.client_name ? res.client_name : "-"}</td>
                                            <td>{agreementTypeLabel(res.agreement_type)}</td>
                                            <td>{res.ip_client ? res.ip_client : "-"}</td>
                                            <td>{res.client_signed_date ? HelperService.getFormatedDateAndTime(res.client_signed_date) : "-"}</td>
                                            <td>{res.advisor_signed_date ? HelperService.getFormatedDateAndTime(res.advisor_signed_date) : "-"}</td>
                                            <td>{res.start_date ? HelperService.getFormatedDateByDMY(res.start_date) : "-"}</td>
                                            <td>{res.end_date ? HelperService.getFormatedDateByDMY(res.end_date) : "-"}</td>
                                            <td className="text-center">
                                                <div className="ml-actions">
                                                    <button type="button" className="ml-act blue" title="Download" onClick={() => download(res.id)}>
                                                        <IconDownload />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>

                    {list?.length == 0 && ShowLoader == false &&
                        <div className="ml-empty">
                            <div className="ml-empty-ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="11" cy="11" r="7" />
                                    <path d="M21 21l-4.3-4.3" />
                                </svg>
                            </div>
                            <h2>No Records Found</h2>
                            <p>Try a different search term.</p>
                        </div>
                    }

                    {totalCount && Number(totalCount) > 0 ?
                        <div className="ml-pager">
                            <div className="ml-total">Total count: <b>{totalCount}</b></div>
                            <div>
                                <SpringMoneyPagination
                                    currentPageNo={currentPage}
                                    setCurrentPageNo={setCurrentPage}
                                    itemsCountPerPage={itemsCountPerPage}
                                    totalItems={Number(totalCount)}
                                    TotalPages={TotalPages}
                                    setTotalPages={setTotalPages}
                                />
                            </div>
                            <div className="ml-goto">
                                <span>Go to page</span>
                                <input
                                    onKeyDown={handleGoToPageInput}
                                    type="number"
                                    value={goToPageNumber}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^[1-9]\d*$/.test(value) || value === "") {
                                            setGoToPageNumber(value);
                                        }
                                    }}
                                />
                                <a title="Next" onClick={() => {
                                    if (goToPageNumber !== "") {
                                        if (TotalPages && (Number(goToPageNumber) > TotalPages)) {
                                            setCurrentPage(TotalPages);
                                        } else {
                                            setCurrentPage(Number(goToPageNumber));
                                        }
                                    }
                                }}>
                                    <IconArrowRight />
                                </a>
                            </div>
                        </div>
                        : null
                    }
                </div>
            </div>
        </>
    );
};
export default ArchivedAgreement;
